import { IUser } from "../models/IUser";
import { makeAutoObservable } from "mobx";
import AuthService from "../services/AuthService";
import axios from "axios";
import { AuthResponse } from "../models/response/AuthResponse";
import { API_URL } from "../appConfig";
import UserService from "../services/UserService";
import { IUserInfo } from "../models/IUserInfo";
import { ISpecInfo } from "../models/ISpecInfo";
import AskService from '../services/AskService'
import { urlLE } from "../appConfig";
import md5 from 'md5'

export default class UserStore {
    user = {} as IUser;
    userInfo = {} as IUserInfo;
    specInfo = {} as ISpecInfo;
    qa = [];
    regProccess = false;
    isAuth = false;
    isLoading = false;
    lang = 'ru';
    refFrom = '';
    refIn = '';
    page = 1;
    pages = 1;
    alumniPage = 1;
    alumniPages = 1;
    searchData = [];
    searchText = ''

    constructor() {
        makeAutoObservable(this);
    };

    setSearchData(data: any) {
        this.searchData = data
    };

    setSearchText(data: string) {
        this.searchText = data
    };

    setAuth(bool: boolean) {
        this.isAuth = bool;
    };

    setUser(user: IUser) {
        this.user = user;
    };

    setSpecInfo(data: ISpecInfo) {
        this.specInfo = data;
    };

    setUserInfo(data: IUserInfo) {
        this.userInfo = data;
    };

    setQA(data: any) {
        this.qa = data;
    };

    setLoading(bool: boolean) {
        this.isLoading = bool;
    };

    setRegProccess(bool: boolean) {
        this.regProccess = bool;
    };

    setLang(lang: string) {
        this.lang = lang;
    };

    setRef(val: string) {
        this.refFrom = this.refIn;
        this.refIn = val;
    };

    setPage(num: number) {
        this.page = num;
    };

    setPages(num: number) {
        this.pages = num;
    };

    setAlumniPage(num: number) {
        this.alumniPage = num;
    };

    setAlumniPages(num: number) {
        this.alumniPages = num;
    };

    async login(email: string, password: string) {
        try {
            const response = await AuthService.login(email, password);
            localStorage.setItem('access', response.data.access);
            localStorage.setItem('refresh', response.data.refresh);
            const userResponse = await UserService.getUser();
            this.setUser(userResponse.data.results[0]);
            if (this.user.is_active) {
                if (this.user.is_staff) {
                    const specRes = await UserService.getSpecInfo();
                    this.setSpecInfo(specRes.data.results[0]);
                } else {
                    const userRes = await UserService.getUserInfo();
                    this.setUserInfo(userRes.data.results[0]);
                };
            };
            this.setAuth(true);
        } catch (e) {
            console.error((e as Error).message);
            alert(this.lang === 'ba' ? 'Үрҙә күрһәтелгән иҫәпкә алыу мәғлүмәттәре менән әүҙем иҫәп яҙмаһы табылманы.' : this.lang === 'ru' ? 'Активная учетная запись с указанными учетными данными не найдена.' : 'No active account found with the given credentials.');
        } finally {
            const resQA = await AskService.getQ();
            this.setQA(resQA.data.results);
        };
    };

    async registration({ email, name, password }: { email: string, name: string, password: string }) {
        const data = { email, name, password, re_password: password };
        this.setRegProccess(true);
        try {
            await AuthService.registration(data);
            alert(this.lang === 'ba' ? 'Аккаунтығыҙҙы әүҙемләштереү өсөн үҙегеҙгә тигән хатта күрһәтелгән һылтанма буйынса үтегеҙ.' : this.lang === 'ru' ? 'Для активации Вашего аккаунта пройдите по ссылке, которая указана в письме в Вашем email.' : 'To activate your account, follow the link that is indicated in the letter in your email.')
            this.setAuth(true);
        } catch (e) {
            console.log((e as Error).message);
            alert(this.lang === 'ba' ?
                'Email һәм пароль индереүҙең дөрөҫлөгөн тикшерегеҙ. Пароль ҡатмарлы булырға тейеш һәм email исеменең өлөшөн ҡабатларға тейеш түгел.'
                : this.lang === 'ru' ?
                    'Проверьте правильность введения email и пароля. Пароль должен быть сложным и не должен повторять часть названия email.'
                    :
                    'Check that the email and password are entered correctly. The password should be complex and should not repeat part of the email name.')
        } finally {
            this.setRegProccess(false);
        };
    };

    async specRegistration({ email, name, password }: { email: string, name: string, password: string }) {
        const data = { email, name, password, re_password: password };
        this.setRegProccess(true);
        try {
            await AuthService.registration(data);
            await AuthService.registrationMail({ email });
            alert(this.lang === 'ba' ? 'Аккаунтығыҙҙы әүҙемләштереү өсөн үҙегеҙгә тигән хатта күрһәтелгән һылтанма буйынса үтегеҙ. Шулай уҡ администраторға белгес ролен билдәләүҙе һорап хат ебәрелде.' : this.lang === 'ru' ? 'Для активации Вашего аккаунта пройдите по ссылке, которая указана в письме в Вашем email. Также администратору отправлено письмо с просьбой установить роль специалиста.' : 'To activate your account, follow the link that is indicated in the letter in your email. Also, an email was sent to the administrator with a request to establish the role of a specialist.')
            this.setAuth(true);
        } catch (e) {
            console.log((e as Error).message);
            alert(this.lang === 'ba' ?
                'Email һәм пароль индереүҙең дөрөҫлөгөн тикшерегеҙ. Пароль ҡатмарлы булырға тейеш һәм email исеменең өлөшөн ҡабатларға тейеш түгел.'
                : this.lang === 'ru' ?
                    'Проверьте правильность введения email и пароля. Пароль должен быть сложным и не должен повторять часть названия email.'
                    :
                    'Check that the email and password are entered correctly. The password should be complex and should not repeat part of the email name.')
        } finally {
            this.setRegProccess(false);
        };
    };

    async logout() {
        try {
            localStorage.removeItem('access');
            localStorage.removeItem('refresh');
            localStorage.removeItem('token');
            this.setAuth(false);
            this.setUser({} as IUser);
            this.setUserInfo({} as IUserInfo);
            this.setSpecInfo({} as ISpecInfo);
            this.setQA([]);
            this.checkAuth();
        } catch (e) {
            console.log(e);
        };
    };

    async checkAuth() {
        this.setLoading(true);
        try {
            const refresh = localStorage.getItem('refresh')
            const response = await axios.post<AuthResponse>(`${API_URL}auth/jwt/refresh`, { refresh });
            localStorage.setItem('access', response.data.access);
            this.setAuth(true);
            const userResponse = await UserService.getUser();
            this.setUser(userResponse.data.results[0]);
            if (this.user.is_active) {
                if (this.user.is_staff) {
                    const specRes = await UserService.getSpecInfo();
                    this.setSpecInfo(specRes.data.results[0]);
                    UserService.createSpecActive({ 'fio': this.specInfo.fio, 'municipality': this.specInfo.municipality })
                } else {
                    const userRes = await UserService.getUserInfo();
                    this.setUserInfo(userRes.data.results[0]);
                };
            };
        } catch (e) {
            console.log(e);
        } finally {
            this.setLoading(false);
            const resQA = await AskService.getQ();
            this.setQA(resQA.data.results);
        };
    };

    async loginToMonitoring() {
        const k = 'Mp#krHpP%wg5=zp2e82Hj+8bTwsRQm!ce5h3h82!c!gfPNv9'
        const ip = await axios.get('http://ip-api.com/json/');
        const secret = "2" + ip.data['query'] + navigator.userAgent + "_" + k

        const data = { 'id': 2, 'ip': ip.data['query'], 'ua': navigator.userAgent, 'secret': md5(secret) };
        const url = urlLE + `reg/auto/demand?demand=${btoa(JSON.stringify(data))}`;
        const res = await axios.get(url);
        return res.data;
    };

};